export default __webpack_public_path__ + "static/media/Private_Equity_20230308.5d767e14.pdf";